// Internal: Used by the HOC to set the current form config
function set(callback){
    return function(dispatch, getState){
        dispatch({
            type: "SET_FORM_CONFIG",
            getData: function(){
                return callback( getState() )
            }
        })
    }
}


export default {
    set
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/form/form-actions.ts